import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_earning,
  add_earning,
  update_earning,
  delete_earning,
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";

const initialState = {
  earning: [],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
    amount: "",
    type: "",
    phone_no: "",
    date:"",
    email: "",
    bank_account:"",
    remark: "",
  },
};

// Async Thunks for API Calls
export const fetchearning = createAsyncThunk(
  "earning/fetchearning",
  async (
    { page, page_size, school_id, token, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_earning(
        page,
        page_size,
        school_id,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createearning = createAsyncThunk(
  "earning/createearning",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_earning(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateearning = createAsyncThunk(
  "earning/updateearning",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_earning(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteearning = createAsyncThunk(
  "earning/deleteearning",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_earning({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// hostel_category Slice
const earningSlice = createSlice({
  name: "earnings",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(reduxState, action) {
      reduxState.formData = { ...action.payload };
    },
    resetFormData(state) {
      state.formData = {
        name: "",
        amount: "",
        type: "",
        date:"",
        phone_no: "",
        email: "",
        bank_account: "",
        remark: "",
      };
    },
    setearning(state, action) {
      state.earning = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder

      // Fetch hostel_category
      .addCase(fetchearning.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchearning.fulfilled, (state, action) => {
        state.loading = false;
        state.earning = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchearning.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add hostel_category
      .addCase(createearning.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createearning.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createearning.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update hostel_category
      .addCase(updateearning.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateearning.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateearning.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete hostel_category
      .addCase(deleteearning.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteearning.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteearning.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setearning,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize,
} = earningSlice.actions;
export default earningSlice.reducer;
